import React, { useState } from 'react';
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import com_logo from "../Home/Home_modules/Im/com_logo.png";
import "../Home/Navbar_module/navbar.css";
import Mobilemenu from '../Home/Navbar_module/Mobile-menu'
import MaterialNav from './MaterialNav.js'
import MobilePublicMenu from './Mobilemenupublic'


function Publicmenu() {
    const [buttonPopUp, setButtonPopUp] = useState(false)
    
    return (
        <div className="nav-container">
        <nav className="nav-full">
        <div className="nav">

            <div>
                <ul>
                    <li><Link to="/"><img className="com-logo" src={com_logo} alt="Logo" /></Link></li>
                </ul>
            </div>
            <div className="list">
                <ul  >
                    <li className='li' ><Link to="/collections">COLLECTIONS</Link></li>
                    <li className='li ' ><Link to="/marketplace">MARKETPLACE</Link></li>
                    <li className='li ' ><Link to="/how it works">HOW IT WORKS</Link></li>
                    <li className='li' ><Link to="/blog">BLOG</Link></li>
                    <li className='li'><Link to="/about">ABOUT</Link></li>
                    {/* <li className='li'><i class='fas fa-wallet' id="wal-ic1" ></i></li> */}
                    <li className='li'><Link to="/wallet"><i class='fas fa-wallet' id="wal-ic" ></i></Link></li>
                    {/* <button className="mob">btn</button> */}
                </ul>
                <div className="ton">
                    {/* <label className="toggleSwitch nolabel">
                        <input type="checkbox" checked />
                        <a></a>
                        <span  >
                            <span className="left-span" ><Link to="/about">Login</Link></span>
                            <span className="right-span" ><Link to="/signup">signup</Link></span>
                        </span>
                    </label> */}
                    
                    
                    <div className="log-btt">
                    <p className="log-btt-text"><Link to="/login">Login</Link></p>
                    </div>
                    <div className="signup-btt">
                    <p  className="log-btt-text-signup"><Link to="/signup">Signup</Link></p>
                    </div>

                </div>
            </div>
        </div>
    </nav>
    <div className="mobile-menu">
    <MobilePublicMenu />
    </div>
    </div>
    )
    
}





export default Publicmenu;

    